import { Box } from "@chakra-ui/react";
import { Activities } from "src/modules/activity-log/activity";

export default function ShadowGradients({ activity, lastNoiseBefore }) {
  return (
    <>
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="72px"
        z-index={-1}
        backgroundImage="linear-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0))"
      />
      <Box
        position="absolute"
        top="0"
        right="0"
        width="120px"
        height="100vh"
        z-index={-1}
        backgroundImage="linear-gradient(to right,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.29))"
      />
      {activity === Activities.SLEEPING && lastNoiseBefore && (
        <Box
          position="absolute"
          bottom="0"
          left="0"
          width="100%"
          height="120px"
          z-index={-1}
          backgroundImage="linear-gradient(to bottom,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.29))"
        />
      )}
    </>
  );
}
